<template>
  <div>
    <menu-item
      :item="menu"
      :key="menu.id"
      v-for="menu in menus"
    />
  </div>
</template>

<script>
import MenuItem from '@/components/menu/MenuItem';
import MenuItemMixin from '@/mixins/MenuItemMixin';

export default {
  name: 'SuperAdminMenu',

  mixins: [
    MenuItemMixin,
  ],

  components: {
    MenuItem,
  },

  computed: {
    menus() {
      return [
        {
          active: this.isActive('super-admin-invites'),
          color: 'orange',
          icon: 'mdi-shield-star',
          title: this.$t('menu.admin'),
          to: 'super-admin-invites',
        },
        {
          active: this.isActive('admin-settings'),
          color: 'blue',
          icon: 'mdi-cog',
          title: this.$t('menu.configs'),
          to: 'admin-settings',
        }
      ].filter(Boolean);
    },
  },
}
</script>
